import config from "../../config/config";
import axios from "axios";
import React, { useState, useEffect } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { Button, Modal } from "react-bootstrap";
import LookupReceiptModal from "./LookupReceiptModal";
import DescriptionModal from "./DescriptionModal";
let LocationItemData = [{}];
let allData = [];

function NewWorkModal({}) {
  // let LocationItemData = [];
  const token = localStorage.getItem("Token");
  const [inputValue, setInputValue] = useState("");
  const [options, setOptions] = useState([]);
  const [custoptions, setCustOptions] = useState([]);
  const [selectedOption, setSelectedOption] = useState("");
  const [selectedcustomer, setSelectedCustomer] = useState("");
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedData, setSelectedData] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [descriptionChange, setDescriptionChange] = useState();

  const toggleModal = () => {
    setShowModal(!showModal);
  };
  const Id = localStorage.getItem("ID");
  let navigate = useNavigate();

  useEffect(() => {
    axios
      .get(`${config.customersBaseUrl}/customers/customerdropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((response) => {
        setCustOptions(response.data.ResponseData);
        // console.log("abcd", response.data.ResponseData);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  const handleDescriptionChange = (event) => {
    setDescriptionChange(event.target.value);
  };

  const handleSelectChange = (event) => {
    console.log("Customer", event);
    setSelectedOption(event.target.value);
    //setSelectedOption(selectedcustomer.Firstname);
    console.log("Customer", event.target.value);
    axios
      .get(
        `${config.customersBaseUrl}/customers/customerdetailforlabel?id=${event.target.value}`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((response) => {
        console.log("abcd", response.data.ResponseData[0]);
        if (
          response.data.ResponseData[0] != undefined &&
          response.data.ResponseData[0] != null
        ) {
          setSelectedCustomer(response.data.ResponseData[0]);
          setSelectedOption("");
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  // Handle Customer and items
  const handleSubmit = () => {
    // To filter all null values
    let WorkOrderItemData = allData.filter(function (workOrderItem) {
      return workOrderItem.ItemId != "";
    });
    const workOrderItemobj = {};
    workOrderItemobj.workorderitemxml = WorkOrderItemData;
    let workorderitemjsonstring = JSON.stringify(workOrderItemobj);
    console.log("workorderitemjsonstring: ", workorderitemjsonstring);

    // setLoading(true);
    axios
      .post(
        `${config.workorderBaseUrl}/workorders/insert`,
        {
          workordersitemxml: workorderitemjsonstring,
          // '{"workorderitemxml":{"workorderid":0,"itemid":1,"itemattributeid":123,"variationid":5}}',
          id: 0,
          customerid: selectedcustomer.Id,
          loginuserid: Id,
        },
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            "Access-Control-Allow-Origin": "*",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        if (res.data.ResponseCode === "SUCCESS" && res.data.ResponseID > 0) {
          // toastSuccess(SUCCESS_MESSAGE);
          navigate(`/editworkorder/${res.data.ResponseID}`);
        } else if (
          res.data.ResponseCode === "ERROR" &&
          res.data.ResponseID === -1
        ) {
          // toastError("Email" + ALREADY_EXIST);
        } else {
          // toastError(ERROR_MESSAGE);
        }
        // setLoading(false);
      })
      .catch((error) => {
        console.log(error);
        // setLoading(false);
      });
  };

  const handleClose = () => {
    setShowDeleteModal(false);
  };

  const [statenew, setStateNew] = useState({});
  const callback = (payload) => {
    console.log("payload =>", payload);
    allData = payload;
    setStateNew(payload);
    console.log("statenew======>", statenew);
  };
  console.log("==========");
  console.log(statenew);
  console.log("==========");

  return (
    <>
      <div
        class="modal fade"
        data-bs-backdrop="static"
        id="NewWorkModal"
        tabindex="-1"
        aria-labelledby="NewWorkModalLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <div class="modal-header">
              <h1 class="modal-title fs-5" id="NewWorkModalLabel">
                New Work Order
              </h1>
              <button
                type="button"
                class="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={handleClose}
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div class="modal-body">
              {/* First CARD and modal body */}
              <div class="card ">
                <div class="card-header row">
                  <div className="col-md-4">
                    <p style={{ fontSize: "20px" }}>Customer</p>
                  </div>
                  <div className="col-md-8 ">
                    <div class="input-group flex-nowrap">
                      <span class="input-group-text" id="addon-wrapping">
                        <a href="google.com">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            fill="currentColor"
                            class="bi bi-person-plus"
                            viewBox="0 0 16 16"
                          >
                            <path d="M6 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm2-3a2 2 0 1 1-4 0 2 2 0 0 1 4 0zm4 8c0 1-1 1-1 1H1s-1 0-1-1 1-4 6-4 6 3 6 4zm-1-.004c-.001-.246-.154-.986-.832-1.664C9.516 10.68 8.289 10 6 10c-2.29 0-3.516.68-4.168 1.332-.678.678-.83 1.418-.832 1.664h10z" />
                            <path
                              fill-rule="evenodd"
                              d="M13.5 5a.5.5 0 0 1 .5.5V7h1.5a.5.5 0 0 1 0 1H14v1.5a.5.5 0 0 1-1 0V8h-1.5a.5.5 0 0 1 0-1H13V5.5a.5.5 0 0 1 .5-.5z"
                            />
                          </svg>
                        </a>
                      </span>
                      <input
                        type="text"
                        class="form-control"
                        placeholder="Type customer name..."
                        list="customer"
                        value={selectedOption}
                        onChange={handleSelectChange}
                      />
                      <datalist id="customer">
                        {custoptions.map((option) => (
                          <option key={option.Id} value={option.Id}>
                            <div className="custom-option">
                              <h1>{option.FirstName}</h1>
                            </div>
                          </option>
                        ))}
                      </datalist>
                    </div>
                  </div>
                </div>
                <div
                  class="card-body text-secondary"
                  style={{ borderTop: "1px solid #e9ecef" }}
                >
                  {/* <h1>
                    {selectedcustomer.Firstname} {selectedcustomer.LastName}
                  </h1> */}
                  <div className="row">
                    <div className="col-md-6">
                      {selectedcustomer.FirstName} {selectedcustomer.LastName}
                    </div>
                    <div className="col-md-6">
                      <div className="pull-right">{selectedcustomer.Email}</div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-6">{selectedcustomer.Address1}</div>
                    <div className="col-md-6">
                      <div className="pull-right">
                        {selectedcustomer.PhoneNumber}
                      </div>
                    </div>
                  </div>
                  <div>
                    {selectedcustomer.StateProvince},{selectedcustomer.City},
                    {selectedcustomer.Zip}
                  </div>
                </div>
              </div>
              {/* First CARD and modal body */}
              {/* Second CARD and modal body */}
              <div class="card">
                <div
                  class="card-header row "
                  //   style={{ borderBottom: "1px solid" }}
                >
                  <div className="col-md-4">
                    <p style={{ fontSize: "20px" }}>Items In This Work Order</p>
                  </div>
                  <div className="col-md-8 ">
                    <SearchableDropdown2
                      callback={callback}
                      options={options}
                    />
                    {/* <div className="text-center mt-1">OR</div> */}
                    <div className="text-center">
                      {/* <button
                        className="btn  btn-outline mt-1"
                        style={{
                          borderColor: "#FF9F43",
                        }}
                        onClick={toggleModal}

                        // hover={{ backgroundColor: "#FF9F43" }}
                      >
                        Add as Repair Item
                      </button> */}
                      {/* Modal Popup */}
                      {/* <Link
                        // to="/manage-customers"
                        className="btn btn-added "
                        data-bs-target="#DescriptionModal"
                        data-bs-toggle="modal"
                      >
                        <i className="fa fa-plus pull-right me-2 lg"></i>
                        Add as Repair Item
                      </Link> */}
                      {/* Modal Popup  */}
                    </div>
                  </div>
                </div>
                <div
                  class="card-body text-secondary"
                  style={{ borderTop: "1px solid #e9ecef" }}
                >
                  <div className="table-responsive">
                    <table className="table table-hover table-bordered table-condensed">
                      <thead>
                        <tr>
                          <th>ItemId</th>
                          <th>ItemName</th>
                          <th>Description</th>
                          <th className="d-none">VariationId</th>
                          <th className="d-none">AttributeId</th>
                        </tr>
                      </thead>
                      <tbody>
                        {allData.map((item) => (
                          <tr key={item.ItemId}>
                            <td>{item.ItemId}</td>
                            <td>{item.ItemName}</td>
                            <td>{item.Description}</td>
                            <td className="d-none">{item.VariationId}</td>
                            <td className="d-none">{item.AttributeId}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>{" "}
                </div>
              </div>
              {/* Second CARD and modal body */}
            </div>
            <div class="modal-footer fs-5 row">
              <div class="col " style={{ borderTop: "1px solid #e9ecef" }}>
                <button
                  type="button"
                  class="btn btn-secondary pull-right mt-2"
                  data-bs-dismiss="modal"
                >
                  Close
                </button>
                <button
                  // to="/editworkorder"
                  type="button"
                  class="btn btn-primary pull-right me-1 mt-2"
                  onClick={handleSubmit}
                  data-bs-dismiss="modal"
                >
                  {/* Save changes*/}
                  <Link class="dropdown-item" to="/editworkorder/:id">
                    Save Changes
                  </Link>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <DescriptionModal />
    </>
  );
}

const SearchableDropdown = ({ callback }) => {
  const token = localStorage.getItem("Token");
  const [suggestions, setSuggestions] = useState([]);
  const [inputValue, setInputValue] = useState("");
  const [tableData, setTableData] = useState([]);

  const [selectedOption, setSelectedOption] = useState(null);

  // const state = {
  //   example: "Hello",
  // };

  // const handleCallback = () => callback({ A: "hello" });

  useEffect(() => {
    // Fetch data from an API
    const fetchData = async () => {
      if (inputValue != "") {
        axios
          .get(
            `${config.itemsBaseUrl}/items/search?searchparam=${inputValue}`,
            {
              headers: {
                "Content-Type": "application/json;charset=UTF-8",
                Authorization: token,
              },
            }
          )
          .then((response) => {
            if (response != "" && response != null) {
              console.log("response =>", response.data.ResponseData);
              const data = response.data.ResponseData;
              if (data[0].ItemId > 0) {
                setSuggestions(data);
                console.log("suggestion", data);
              } else {
                setSuggestions([]);
              }
            }
          })
          .catch((error) => {});
      } else {
        setSuggestions([]);
      }
    };

    fetchData();
  }, [inputValue]);

  const handleInputChange = (event) => {
    const value = event.target.value;
    setInputValue(value);

    if (!value) {
      setSuggestions([]);
    }
  };

  const handleInputClick = (
    // event,
    pItemId,
    pItemName,
    pDescription,
    pVariationId,
    pAttributeId
  ) => {
    console.log("pItemId =>", pItemId);
    console.log("pItemName =>", pItemName);
    console.log("pDescription =>", pDescription);
    console.log("pVariationId =>", pVariationId);
    console.log("pAttributeId =>", pAttributeId);
    const selectedOption = {
      WorkOrderId: 0,
      ItemId: pItemId,
      ItemName: pItemName,
      Description: pDescription,
      VariationId: pVariationId,
      AttributeId: pAttributeId,
    };

    console.log("selectedOption =>", selectedOption);
    setTableData([...tableData, selectedOption]);

    setInputValue("");
    setSuggestions([]);
  };

  useEffect(() => {
    const locationItemData = tableData.filter((locationItem) => {
      return locationItem.ItemId !== "";
    });

    callback(locationItemData);
  }, [tableData]);

  // handleCallback();
  // callback(LocationItemData);

  return (
    <div className="container">
      <form>
        <div className="mb-3">
          {/* <input type="text" className="form-control" value={inputValue} onChange={handleInputChange} /> */}
          <div class="input-group flex-nowrap">
            <span class="input-group-text" id="addon-wrapping">
              <a href="google.com">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  class="bi bi-pencil-square"
                  viewBox="0 0 16 16"
                >
                  <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z" />
                  <path
                    fill-rule="evenodd"
                    d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5v11z"
                  />
                </svg>
              </a>
            </span>

            <input
              type="text"
              class="form-control"
              placeholder="Type item name or scan barcode"
              value={inputValue}
              onChange={handleInputChange}
            />
          </div>
        </div>
        {suggestions.length > 0 ? (
          <div className="dropdown">
            <ul className="dropdown-menu w-100 show">
              {suggestions.map((item) => (
                <li
                  key={item.ItemId}
                  onClick={(e) =>
                    handleInputClick(
                      item.ItemId,
                      item.ItemName,
                      item.Description,
                      item.VariationId,
                      item.AttributeId
                    )
                  }
                >
                  <a
                    key={item.ItemId}
                    href="#"
                    className="dropdown-item"
                    data-name={item.ItemName.toLowerCase()}
                    // onClick={handleInputClick(item.ItemId,item.ItemName)}
                  >
                    <img
                      src={item.ImageName}
                      onError={(e) => {
                        e.currentTarget.src =
                          "https://th.bing.com/th/id/OIP.ADcGkW6WTfq2zu8yoY8vlgHaHa?w=197&h=197&c=7&r=0&o=5&pid=1.7";
                      }}
                      alt={item.ItemName}
                      className="img-thumbnail rounded-circle mr-5"
                      width="65px"
                      height="65px"
                    />
                    <div className="customer-info">
                      <h6 className="name">{item.ItemName}</h6>
                      <div>
                        Cost Price: {parseFloat(item.CostPrice).toFixed(2)} |
                        Promo Price: {parseFloat(item.PromoPrice).toFixed(2)} |
                        Unit Price: {parseFloat(item.UnitPrice).toFixed(2)}
                      </div>
                      <div>
                        Qty: {parseInt(item.itemquantity)} | Categorie:{" "}
                        {item.CategoryName}
                      </div>
                      {/* Add any other customer details here */}
                    </div>
                  </a>
                </li>
              ))}
            </ul>
          </div>
        ) : (
          ""
        )}
      </form>
    </div>
  );
};

const SearchableDropdown2 = ({ callback }) => {
  const token = localStorage.getItem("Token");
  const [suggestions, setSuggestions] = useState([]);
  const [inputValue, setInputValue] = useState("");
  const [tableData, setTableData] = useState([]);

  useEffect(() => {
    // Fetch data from an API
    const fetchData = async () => {
      if (inputValue != "") {
        axios
          .get(
            `${config.itemsBaseUrl}/items/search?searchparam=${inputValue}`,
            {
              headers: {
                "Content-Type": "application/json;charset=UTF-8",
                Authorization: token,
              },
            }
          )
          .then((response) => {
            console.log("response", response);
            if (response != "" && response != null) {
              console.log("response =>", response.data.ResponseData);
              const data = response.data.ResponseData;
              if (data[0].ItemId > 0) {
                setSuggestions(data);
                console.log("Suggestions", data);
              } else {
                setSuggestions([]);
              }
            }
          })
          .catch((error) => {});
      } else {
        setSuggestions([]);
      }
    };

    fetchData();
  }, [inputValue]);

  const handleInputChange = (event) => {
    const value = event.target.value;
    setInputValue(value);
    console.log("value =>", value);

    if (!value) {
      setSuggestions([]);
    }
  };

  const handleInputClick = (
    pItemId,
    pItemName,
    pDescription,
    pVariationId,
    pAttributeId,
    pModule
    // pItemKitId
  ) => {
    if (pModule == "ItemKit") {
      axios
        .get(
          `${config.itemKitsBaseUrl}/itemkits/itemkitsitemslisting?itemkitid=${pItemId}`,
          {
            headers: {
              "Content-Type": "application/json;charset=UTF-8",
              Authorization: token,
            },
          }
        )
        .then((response) => {
          console.log("response of the item kits", response);
          if (response != "" && response != null) {
            const responsedata = response.data.ResponseData[0];
            const data = {
              WorkOrderId: 0,
              ItemId: responsedata.ItemId,
              ItemName: responsedata.ItemName,
              Description: responsedata.Description,
              VariationId: responsedata.VariationId,
              AttributeId: responsedata.AttributeId,
            };
            console.log("response =>", data);
            setSuggestions(data, () => {
              console.log("Suggestions", suggestions);
            });
            setTableData([...tableData, data]); // add this line
          }
        })
        .catch((error) => {});
    } else {
      const selectedOption = {
        WorkOrderId: 0,
        ItemId: pItemId,
        ItemName: pItemName,
        Description: pDescription,
        VariationId: pVariationId,
        AttributeId: pAttributeId,
        // Module: pModule,
        // Itemkitid: 0,
        // ItemKitId: pItemId
      };
      console.log("selectedOption", selectedOption);
      console.log("pModule", pModule);
      console.log("pItemId", pItemId);

      setSuggestions([selectedOption]);
      console.log("Suggestions", [selectedOption]);
      setTableData([...tableData, selectedOption]); // add this line
    }
    // // setTableData([...tableData, selectedOption]);
    // setTableData([selectedOption]);
    setInputValue("");
    setSuggestions([]);
  };

  useEffect(() => {
    console.log("tableData =>>", tableData);
    const locationItemData = tableData.filter((locationItem) => {
      console.log("locationItem", locationItem.ItemId);
      return locationItem.ItemId !== "";
    });

    callback(locationItemData);
    console.log("locationItemData =>", locationItemData);
  }, [tableData]);

  return (
    <div className="container">
      <form>
        <div className="mb-3">
          <div className="input-group flex-nowrap">
            <span className="input-group-text" id="addon-wrapping">
              <Link to="/manage-items">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  className="bi bi-pencil-square"
                  viewBox="0 0 16 16"
                >
                  <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z" />
                  <path
                    fillRule="evenodd"
                    d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5v11z"
                  />
                </svg>
              </Link>
            </span>

            <input
              type="text"
              className="form-control"
              placeholder="Type item name or scan barcode"
              value={inputValue}
              onChange={handleInputChange}
              // disabled={disabled}
            />
          </div>
        </div>
        {suggestions.length > 0 ? (
          <div className="dropdown">
            <ul className="dropdown-menu w-100 show">
              <span>{console.log(suggestions)}</span>

              {suggestions.map((item) => (
                <li
                  key={item.ItemId}
                  onClick={() =>
                    handleInputClick(
                      item.ItemId,
                      item.ItemName,
                      item.VariationName,
                      item.UnitPrice,
                      item.itemquantity,
                      item.Module,
                      item.Description,
                      item.VariationId,
                      item.AttributeId

                      // item.ItemKitId
                    )
                  }
                >
                  <Link
                    key={item.ItemId}
                    href="#"
                    className="dropdown-item"
                    data-name={item.ItemName?.toLowerCase()}
                  >
                    <img
                      src={item.ImageName}
                      onError={(e) => {
                        e.currentTarget.src =
                          "https://th.bing.com/th/id/OIP.ADcGkW6WTfq2zu8yoY8vlgHaHa?w=197&h=197&c=7&r=0&o=5&pid=1.7";
                      }}
                      alt={item.ItemName}
                      className="img-thumbnail rounded-circle mr-5"
                      width="65px"
                      height="65px"
                    />
                    <div className="customer-info">
                      <h6 className="name">
                        {item.ItemName}({item.VariationName})
                      </h6>
                      <div>
                        Cost Price: {parseFloat(item.CostPrice).toFixed(2)} |
                        Promo Price: {parseFloat(item.PromoPrice).toFixed(2)}|
                        Unit Price: {parseFloat(item.UnitPrice).toFixed(2)}
                      </div>
                      <div>
                        Qty: {parseInt(item.itemquantity)} | Categories:
                        {item.CategoryName}
                      </div>
                      {/* Add any other customer details here */}
                    </div>
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        ) : (
          ""
        )}
      </form>

      <LookupReceiptModal />
    </div>
  );
};
export default NewWorkModal;
